import { Box, Typography, useMediaQuery } from "@mui/material";
import { useTheme } from "@emotion/react";
import { STORAGE_URL } from "../constants";
import { useNavigate } from "react-router-dom";

const BackButton = ({ title = "BACK", onClick, customBack = false }) => {
  const { palette, ...theme } = useTheme();
  const isMobile = useMediaQuery("(max-width:599px)");
  const isMd = useMediaQuery(theme.breakpoints.up('md'));
  const isSm = useMediaQuery(theme.breakpoints.only("sm"));
  const isLg = useMediaQuery(theme.breakpoints.only("lg"));
  const navigate = useNavigate();
  const path = window.location.pathname
    .split("/")
    .slice(0, window.location.pathname.split("/").length - 1)
    .join("/");
  return (
    <Box
      onClick={() =>
        customBack ? onClick() : navigate(path === "" ? "/" : path)
      }
      display="flex"
      sx={{
        cursor: "var(--pointer-cursor)",
        transition: "all .4s ease-in-out",
        ".back-button-text": {},
        "&:hover": {
          marginLeft: "2px",
        },
        [theme.breakpoints.down("md")]: {
        width:"auto",

      
         
        }
      }}
      width="7vw"
      alignItems="center"
      justifyContent="flex-start"
    >
      <img
        style={{
          width:isLg?"50px":isMd?"40px" : isMobile ? "20px" : "30px",
          margin:isMd?"0px":"10px 10px",
          color: "#ffffff",
          marginRight: "10px",
        }}
        src={`${STORAGE_URL}bayc-3d/backbtn.png`}
      />
      <Typography
        // className="back-button-text"
        sx={{
          fontWeight: "500",
          textTransform: "capitalize",
          fontFamily: "var(--font-g)",
          fontSize: "0.8vm",
          color: "#E3DFD6",
          alignItems: "center",  
          [theme.breakpoints.down("sm")]: {
            fontSize: "22px",
          },
          [theme.breakpoints.down("md")]: {

           alignItems:"center",
         
            whiteSpace: 'nowrap',
          },
          
        }}
      >
        {title}
      </Typography>
    </Box>
  );
};

export default BackButton;
